var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-main',[_c('akcd_overview')],1),_c('navBar',{attrs:{"title":"Ares - Reference data","home":true,"type":"referencedata"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }